import React, { ReactNode } from 'react';
import { LineItem } from '../../../../../../atoms/LineItem/LineItem';
import { StepNumber, Steps } from './InstructionList.styles';

export type InstructionListProps = {
  instructions: ReactNode[];
};

export const InstructionListBody: React.FC<InstructionListProps> = ({ instructions }) => {
  return (
    <Steps>
      {instructions.map((text, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <LineItem key={index} index={<StepNumber>{index + 1}</StepNumber>}>
          {text}
        </LineItem>
      ))}
    </Steps>
  );
};
